import React, { PureComponent } from 'react';
import { FiDownload, FiX } from 'react-icons/fi';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ModalBase from '../modal-base';

const Image = styled.img`
  width: auto;
  height: auto;
  max-height: 90%;
  max-width: 90%;
  margin: 0 auto;

  @media (min-width: 768px) {
    max-width: 40em;
  }
`;

const Download = styled.a`
  color: white;
  position: fixed;
  padding: 0.5rem;
  top: 0;
  right: 4rem;
  cursor: pointer;
  font-size: 3rem;
  > svg {
    display: block;
  }
`;

const Close = styled.div`
  color: white;
  position: fixed;
  padding: 0.5rem;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 3rem;
  > svg {
    display: block;
  }
`;

class ImageLightBox extends PureComponent {
  state = {
    downloadLink: null
  };
  componentDidMount() {
    if (this.props.canDownload) {
      fetch(this.props.src, { mode: 'cors' })
        .then(res => res.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          this.setState({
            downloadLink: url
          });
        });
    }
  }

  downloadClick = ev => {
    ev.stopPropagation();
  };

  render() {
    return (
      <ModalBase onClose={this.props.onClose} opacity={0.8}>
        <Image src={this.props.src} />
        {this.state.downloadLink && (
          <Download
            download
            href={this.state.downloadLink}
            onClick={this.downloadClick}
          >
            <FiDownload />
          </Download>
        )}
        <Close onClick={this.props.onClose}>
          <FiX />
        </Close>
      </ModalBase>
    );
  }
}

ImageLightBox.propTypes = {
  src: PropTypes.string.isRequired,
  canDownload: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

export default ImageLightBox;
